/**
 * The vehicle module's paths.
 *
 * Declared here rather than in `layout/nav-items.ts` because the detail page is
 * not a nav entry — it is reached from the fleet list, from the map popover and
 * from an alert — and every one of those call sites needs the same builder.
 * Route registration itself lives in `routes/app-routes.tsx`, which another agent
 * owns this phase; see NOTES-PHASE2-DETAIL.md §1 for the two lines to add.
 */
export const VEHICLES_PATH = '/vehicles'
export const VEHICLE_DETAIL_PATH = '/vehicles/:vehicleId'

export function vehicleDetailPath(vehicleId: string): string {
  return `${VEHICLES_PATH}/${vehicleId}`
}
